import SectionHeading from "./SectionHeading";

const steps = [
  {
    n: "01",
    title: "先确定观看动机",
    desc: "想看故事、想看表演，还是想讨论议题？目的不同，选片方向也不同：偏故事从都市与婚姻题材入手，偏议题从禁忌与罪罚题材入手。",
  },
  {
    n: "02",
    title: "再读分级与主题标签",
    desc: "R 与 NC-17 意味着内容强度更高。先看分级，再看主题标签，能提前判断这部片是否触及你不愿面对的议题。",
  },
  {
    n: "03",
    title: "确认你看的是哪个版本",
    desc: "留意片尾时长。院线版更紧凑，导演剪辑版更完整；如果你在意角色动机的连贯，可以从导演版开始。",
  },
  {
    n: "04",
    title: "给自己留出暂停的空间",
    desc: "这类影片情绪密度偏高，不必强求一口气看完。中途停下来想一想，往往比追进度更能理解它想说什么。",
  },
];

const fits = [
  "对人性与亲密关系议题抱有好奇",
  "能接受没有标准答案、甚至有点难受的结局",
  "喜欢由人物、对白与情绪推动的剧情片",
];

const cautions = [
  "对亲密场面或强烈情绪较为敏感",
  "希望影片给出明确的善恶判断",
  "容易在观影后长时间被情绪影响",
];

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Viewing guide"
          title="观影指引：如何挑选，如何进入"
          desc="伦理片并不难懂，但更适合带着准备去看。以下几步能帮你更快找到适合自己的作品，并看懂它在说什么。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <ol className="space-y-4">
              {steps.map((s) => (
                <li
                  key={s.n}
                  className="flex gap-4 md:gap-5 rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6"
                >
                  <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold text-sm">
                    {s.n}
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {s.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{s.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg bg-secondary-50 border border-secondary-200 p-6">
              <div className="flex items-center gap-2">
                <i className="ri-thumb-up-line text-lg text-secondary-700"></i>
                <h3 className="font-heading text-base font-semibold text-foreground-950">可能很适合你，如果</h3>
              </div>
              <ul className="mt-4 space-y-2.5">
                {fits.map((f) => (
                  <li key={f} className="flex items-start gap-2.5">
                    <i className="ri-check-line text-secondary-600 text-base mt-0.5 shrink-0"></i>
                    <span className="text-sm leading-relaxed text-foreground-700">{f}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg bg-accent-50 border border-accent-200 p-6">
              <div className="flex items-center gap-2">
                <i className="ri-error-warning-line text-lg text-accent-700"></i>
                <h3 className="font-heading text-base font-semibold text-foreground-950">建议先斟酌，如果</h3>
              </div>
              <ul className="mt-4 space-y-2.5">
                {cautions.map((c) => (
                  <li key={c} className="flex items-start gap-2.5">
                    <i className="ri-subtract-line text-accent-600 text-base mt-0.5 shrink-0"></i>
                    <span className="text-sm leading-relaxed text-foreground-700">{c}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}